/** Papéis de plataforma (auth-service user_roles → JWT roles[]). */

export const ROLE_SUPER_ADMIN = 'super_admin';

export function normalizeRoles(user) {
  if (!user) return [];
  const raw = user.roles || [];
  if (!Array.isArray(raw)) return [];
  return raw.map((r) => String(typeof r === 'string' ? r : r?.name || r?.code || r).toLowerCase());
}

export function isSuperAdminUser(user) {
  return normalizeRoles(user).includes(ROLE_SUPER_ADMIN);
}

/** Super admin da plataforma sem vínculo a tenant — só console SaaS. */
export function isPlatformOnlySuperAdmin(user) {
  if (!isSuperAdminUser(user)) return false;
  const org = user?.organization_id;
  return org == null || org === '';
}
